export default __webpack_public_path__ + "../staticImages/sprite-besterOnlineWein-2x.png";